import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

/** An error from the Sparta step of a profile save, raised after Viewpoint already saved (Bug 36400). */
export type ViewpointSavedError<E = unknown> = E & { viewpointSaved: true };

/**
 * Bug 36400: save the profile to Viewpoint first, then to Sparta, which forwards the Email/Cell Phone to Software
 * Security. They used to run in a forkJoin, so a failure could not say whether Viewpoint had saved. A Sparta failure
 * is rethrown with `viewpointSaved: true` (status and body kept) so the callers can name what saved and what did not.
 */
export function saveViewpointThenSparta<T>(
  viewpoint$: Observable<unknown>,
  sparta: () => Observable<unknown>,
  result: T
): Observable<T> {
  return viewpoint$.pipe(
    switchMap(() =>
      sparta().pipe(
        catchError((err) =>
          throwError((): ViewpointSavedError => ({
            ...err,
            viewpointSaved: true,
          }))
        )
      )
    ),
    map(() => result)
  );
}
